'use strict';

const SVGView = require('common/ui/view/svg/index');

const RectSelectorView = SVGView.extend({
    tagName: 'rect',

    initialize: function(opts) {
        RectSelectorView.__super__.initialize.call(this, opts);

        this._start = opts.start;
        this._end = {x: NaN, y: NaN};
    },

    onRender: function() {
        this.$el
            .classed('overRect', true)
            .attr('x', this._start.x)
            .attr('y', this._start.y)
            .attr('width', 0)
            .attr('height', 0)
            .attr('pointer-events', 'none');
    },

    update: function(pos) {
        this._end = pos;

        const topLeft = this.topLeft();
        this.$el
            .attr('x', topLeft.x)
            .attr('y', topLeft.y)
            .attr('width', Math.abs(this._start.x - this._end.x))
            .attr('height', Math.abs(this._start.y - this._end.y));
    },

    topLeft: function() {
        return {
            x: Math.min(this._start.x, this._end.x),
            y: Math.min(this._start.y, this._end.y)
        };
    },

    bottomRight: function () {
        return {
            x: Math.max(this._start.x, this._end.x),
            y: Math.max(this._start.y, this._end.y)
        };
    }
});

module.exports = RectSelectorView;



// WEBPACK FOOTER //
// ./system/ui/view/rect-selector.js